import API, { DATA_API } from 'helpers/api'
import { Grade } from './grade'

export async function getStaffListAskedForAppointment({
  accountIds,
  filters,
  signal,
}: getStaffListAskedForAppointmentInput) {
  if (!accountIds.length) {
    return { summary: {}, records: [] } as never as Response
  }

  const data = {
    accountIds,
    filters,
  }

  const source = API.getCancelToken().source()

  const promise = API.get<Response>({
    api: DATA_API,
    url: '/calls/metrics/staff-asked-for-appointment',
    params: data,
    cancelToken: source.token,
  })

  // Cancel the request if TanStack Query signals to abort
  signal?.addEventListener('abort', () => {
    source.cancel('Query was cancelled by TanStack Query')
  })

  return promise
}

export type getStaffListAskedForAppointmentInput = {
  accountIds: string[]
  filters: {}
  signal?: AbortSignal
}

export type Response = {
  summary: {
    total: number
    askedForAppointment: number
    askedForAppointmentPercentage: number
    askedForAppointmentGrade: Grade
  }
  records: Array<{
    callHandlerId: string
    callHandlerName: string
    total: number
    askedForAppointmentTotal: number
    askedForAppointmentPercentage: number
    askedForAppointmentGrade: Grade
  }>
}
